import * as React from 'react';
import { Breadcrumbs } from '@repo/ui-web';
import { StateToggle } from '../../components/StateToggle';

export function BreadcrumbsShowcase() {
  const variants = ['default', 'deep-path', 'single-item'] as const;
  type BreadcrumbVariant = (typeof variants)[number];

  const [variant, setVariant] = React.useState<BreadcrumbVariant>('default');

  const variantMap: Record<
    BreadcrumbVariant,
    { title: string; items: { label: string; href?: string }[] }
  > = {
    default: {
      title: 'Default',
      items: [
        { label: 'Home', href: '#' },
        { label: 'Settings', href: '#' },
        { label: 'Profile' },
      ],
    },
    'deep-path': {
      title: 'Deep path',
      items: [
        { label: 'Dashboard', href: '#' },
        { label: 'Projects', href: '#' },
        { label: 'Acme Corp', href: '#' },
        { label: 'Settings', href: '#' },
        { label: 'Members' },
      ],
    },
    'single-item': {
      title: 'Single item',
      items: [{ label: 'Home' }],
    },
  };

  const activeVariant = variantMap[variant];

  return (
    <div className="space-y-4">
      <StateToggle
        options={variants}
        value={variant}
        onChange={setVariant}
        label="Variant"
        formatLabel={(value) =>
          value
            .split('-')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(' ')
        }
      />
      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">{activeVariant.title}</p>
        <Breadcrumbs items={activeVariant.items} />
      </div>
    </div>
  );
}
